'use es6';

import { OrderedSet } from 'immutable';
import PortalIdParser from 'PortalIdParser';
import { DEALS } from 'reporting-data/constants/dataTypes';
import { defaultProperties } from 'reporting-data/config/drilldown/defaultProperties';
import { isSearch, getCustomWidgetType, getBucketField, getBreakdownField } from './helpers';
import { WATERFALL_DRILLDOWN_FIELDS } from '../../Waterfall/constants';
const PORTAL_ID = PortalIdParser.get();
export const DEFAULT_FIELDS = [...defaultProperties[DEALS], 'hubspot_owner_id', 'hubspot_team_id'];
const ORDERED_FIELDS = ['dealname', 'closedate', 'snapshot_period_closedate', 'initialCloseDate', 'finalCloseDate', 'mostRecentPushInitialCloseDate', 'mostRecentPushFinalCloseDate', 'dealstage', 'snapshot_period_dealstage', 'finalPipelineStage', 'pipeline', 'amount_in_home_currency', 'snapshot_period_amount_in_home_currency', 'initialAmountInHomeCurrency', 'finalAmountInHomeCurrency', 'amountInHomeCurrencyChange', 'hs_manual_forecast_category', 'hs_analytics_source', 'closedWonReason', 'closedLostReason', 'numberOfPushes', 'createdate', 'hubspot_owner_id', 'hubspot_team_id'];
const onDealNameClick = ({
  row
}) => {
  window.open(`/contacts/${PORTAL_ID}/deal/${row.get('objectId')}/`, '_blank');
};
const getFilterValueByField = (report, field) => {
  const fieldFilter = report.getIn(['config', 'filters', 'custom']).find(filter => filter.get('property') === field);
  return fieldFilter && fieldFilter.get('value');
};
const GET_ADDITIONAL_FIELDS = {
  SALES_QUOTA: report => {
    const bucketField = getBucketField(report);
    return bucketField ? [bucketField] : [];
  },
  PIPELINE_SNAPSHOTS: () => ['snapshot_period_closedate', 'snapshot_period_dealstage', 'snapshot_period_amount_in_home_currency', 'createdate'],
  DEAL_PUSH_ANALYSIS: report => {
    const bucketField = getBucketField(report);
    const breakdownField = getBreakdownField(report);
    if (getFilterValueByField(report, breakdownField) === 'PUSHED') {
      return [bucketField, 'numberOfPushes', 'mostRecentPushInitialCloseDate', 'mostRecentPushFinalCloseDate'];
    }
    return [bucketField];
  },
  WATERFALL: report => {
    const bucketField = getBucketField(report);
    const bucket = getFilterValueByField(report, bucketField);
    return (WATERFALL_DRILLDOWN_FIELDS[bucket] || []).concat(['createdate']);
  },
  CHANGE_HISTORY_DEAL_LIST: () => ['hs_manual_forecast_category']
};
const EXCLUDED_FIELDS = {
  DEAL_PUSH_ANALYSIS: ['amount_in_home_currency'],
  WATERFALL: ['hubspot_owner_id']
};
export const getDrilldownFields = report => {
  if (!isSearch(report)) {
    return [];
  }
  const widgetType = getCustomWidgetType(report);
  const additionalFields = GET_ADDITIONAL_FIELDS[widgetType] ? GET_ADDITIONAL_FIELDS[widgetType](report) : [];
  const excludedFields = EXCLUDED_FIELDS[widgetType] || [];
  return OrderedSet(ORDERED_FIELDS).intersect(OrderedSet([...DEFAULT_FIELDS, ...additionalFields])).subtract(OrderedSet(excludedFields)).toArray();
};
export const getDrilldownColumns = report => getDrilldownFields(report).map(field => Object.assign({
  dataset: 'primary',
  field
}, field === 'dealname' ? {
  onClick: onDealNameClick
} : {}));